module.exports = __webpack_public_path__ + "img/sintesis.a725e248.svg";